import React, { useState, useEffect, useCallback } from 'react'
import usePlacesAutocomplete, {
    getGeocode,
    getDetails,
    getLatLng,
} from "use-places-autocomplete";
import { Container, Row, Col, Card, Tab, Form, Button, Nav, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap'

export default function AddressAutocomplete({ onSelect, defaultAddress = "", disabled = false, inputId = "" }) {
    const {
        ready,
        value,
        suggestions: { status, data },
        setValue,
        clearSuggestions,
    } = usePlacesAutocomplete({
        requestOptions: {
            /* Define search scope here */
        },
        debounce: 300,
    });


    useEffect(() => {
        if (defaultAddress) {
            setValue(defaultAddress, false);
        }
    }, [defaultAddress, setValue]);

    const handleSelect = async (address) => {
        setValue(address, false);
        clearSuggestions();

        try {
            const results = await getGeocode({ address });
            const details = await getDetails({ placeId: results[0].place_id });
            const latLng = await getLatLng(results[0]);

            // You can parse the full address components from details
            onSelect({ address, latLng, details });
        } catch (error) {
            console.error("Error fetching details:", error);
        }
    };

    return (
        <div className="address-autocomplete-wrapper" style={{ position: 'relative', width: '100%' }}>
            <Form.Control
                id={inputId || undefined}
                type="text"
                placeholder="Enter an address"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onBlur={(e) => {
                    // Sync the typed/pasted address back to parent on blur
                    // This handles cases where user types/pastes instead of selecting from dropdown
                    if (e.target.value && e.target.value.trim()) {
                        onSelect({ 
                            address: e.target.value, 
                            latLng: null, 
                            details: { address_components: [] } 
                        });
                    }
                }}
                disabled={disabled || !ready}
                autoComplete="off"
                className="form-control"
            />
            {status === "OK" && data && data.length > 0 && (
                <ul className="address-suggestions-list" style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    backgroundColor: '#fff',
                    border: '1px solid #ccc',
                    borderTop: 'none',
                    listStyle: 'none',
                    padding: 0,
                    margin: '0',
                    maxHeight: '300px',
                    overflowY: 'scroll',
                    overflowX: 'hidden',
                    zIndex: 1050,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}>
                    {data.map(({ place_id, description }) => (
                        <li
                            key={place_id}
                            onClick={() => handleSelect(description)}
                            style={{
                                padding: '10px 12px',
                                cursor: 'pointer',
                                borderBottom: '1px solid #eee',
                                fontSize: '14px',
                                backgroundColor: '#fff',
                                transition: 'background-color 0.2s'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                        >
                            {description}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
